<template>
    <Notifications hide-title />
</template>

<script setup>
    import Notifications from '@/components/shared/Notifications.vue'

    const props = defineProps({
        config: Object,
    })
</script>
